import React from "react";
import styled from "styled-components";
import { Container, useMediaQuery } from "@mui/material";
import VideoSection from "./VideoSection";
import { Computercategories, Phonecategories } from "./categories";
import { SoundCloudSection } from "./SoundCloudSection";
import Logo from "./image/Logo.png";

const BackgroundWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.background.default};
  min-height: 100vh;
  padding-bottom: 0rem;
`;

const StyledContainer = styled(Container)`
  padding-top: 1rem;
  padding-bottom: 1rem;

  @media (min-width: 600px) {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    height: 200px;
    margin-bottom: 1rem;
  }

  @media (min-width: 601px) {
    height: 250px;
    margin-bottom: 0rem;
  }
`;

const StyledLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;

  @media (max-width: 600px) {
    max-width: 90%;
  }

  @media (min-width: 601px) {
    max-width: 80%;
  }
`;

const RecordingStudioWebsite = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const categories = isMobile ? Phonecategories : Computercategories;

  return (
    <BackgroundWrapper>
      <StyledContainer maxWidth="lg">
        <LogoWrapper>
          <StyledLogo src={Logo} alt="Recording Studio Logo" />
        </LogoWrapper>
        {categories.map((category, index) => (
          <React.Fragment key={category.name}>
            {category.videos ? (
              <VideoSection name={category.name} videos={category.videos} />
            ) : category.soundcloud ? (
              <SoundCloudSection
                name={category.name}
                soundcloudUrl={category.soundcloud.src}
                fallbackInfo={{
                  title: "Winning Shot EP - Trailerized Rock",
                  artist: "Composed by Dor Rozen & Yoav Asif",
                  description:
                    "Original soundtrack for 'Winning Shot'. Badass guitar riffs, electric bass grooves and bragging rock drums for those who can rewrite the rules! Featuring modern sound design, intense metal-core drums and dirty bass guitar packed with an oriental shade.",
                }}
              />
            ) : null}
          </React.Fragment>
        ))}
      </StyledContainer>
    </BackgroundWrapper>
  );
};

export default RecordingStudioWebsite;
